import { AxiosInstance } from 'axios'
import { Dispatch } from 'redux'
import { flagData } from '../components/singleObject'
import { setFlagsAction } from '../components/singleDeviation/store/actions'
import { DataType } from '../components/tablesConfig/filterconfig'

/**
 * Hämtar en individs flaggor.
 *
 * Returnerar `'nekad'` när backend svarar 403. Vakten mot direktlänkar (#7) fanns redan
 * i `BrukareController`, men felet swaldes här — sidan renderade tomhet, vilket för
 * användaren är omöjligt att skilja från "den här brukaren har inga flaggor". Skyddet
 * fanns i datan utan att synas, alltså precis det #50 skulle bort med på ruttnivå.
 *
 * Övriga fel loggas som förut och ger `undefined` — de ska inte se ut som ett nekande.
 */
export const setFlags = async (api: AxiosInstance, dispatch: Dispatch, type: string, key: string): Promise<'nekad' | void> => {
  // Personal hämtas på Pejlens id, aldrig på namn (#99)
  const name = type === 'brukare' ? 'personnummer' : type === 'medarbetare' ? 'id' : 'name'

  try {
    const flags = await api.get(`/v1/${type}/${localStorage.getItem('tenant_id')}/${name}/${key}?id_token=${localStorage.getItem('hydra_id_token')}`, {
      headers: {
        authorization: 'Bearer ' + localStorage.getItem('hydra_access_token'),
      },
    })

    const formattedData = flags.data.map((item: any) => {
      return {
        key: item.id,
        id: item.id,
        flagga: item.flagga,
        flaggnamn: item.flaggnamn,
        nivå: item.nivå,
        från: item.från,
        till: item.till,
        created: item.created,
        utförare: item.utförare,
        ansvarig_handläggare: item.ansvarig_handläggare,
        hantering: item.hantering,
      }
    })

    setFlagsAction('SET_FLAGS', formattedData, dispatch)
  } catch (err) {
    // Töm listan innan vi rapporterar — annars ligger föregående individs flaggor kvar
    // i redux och skulle visas bakom felmeddelandet.
    setFlagsAction('SET_FLAGS', [], dispatch)

    if ((err as { response?: { status?: number } })?.response?.status === 403) {
      return 'nekad'
    }

    console.log(err)
  }
}
